import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex w-full justify-end" }

import BaseButton from '@/components/base/BaseButton.vue'
import BaseDialog from '@/components/base/BaseDialog.vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'AlreadyApprovedErrorDialog'
},
  __name: 'AlreadyApprovedErrorDialog',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const emit = __emit



const router = useRouter()
const { t } = useI18n()

const close = (): void => {
  router.back()
  emit('close')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseDialog, {
    "hide-cancel-icon": "",
    title: _unref(t)('entry.already_approved_error.title')
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(BaseButton, {
          filled: "",
          onClick: close
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('general.return_back_and_close')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("h3", null, _toDisplayString(_unref(t)('entry.already_approved_error.details')), 1)
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})